import React from "react";
import PriceConfigurationPage from "./PriceConfiguration";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { PriceConfigurationContextProvider } from "./context/PriceConfigurationContextProvider";

const PriceConfigPage = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      mutations: {
        // Default options for all mutations
        retry: 1, // Number of retry attempts
        onSuccess: (data) => {
          console.log("Mutation succeeded:", data);
        },
        onError: (error) => {
          console.error("Mutation failed:", error);
        },
      },
    },
  });
  return (
    <PriceConfigurationContextProvider>
      <QueryClientProvider client={queryClient}>
        <PriceConfigurationPage />
      </QueryClientProvider>
    </PriceConfigurationContextProvider>
  );
};

export default PriceConfigPage;
